import * as React from 'react'

import { sendToAnalytics } from '../Analytics'

// Returns an onChange-friendly tracker for the "search apps" boxes that appear
// in several places (the import dialog picker, the Explore Applications grid,
// the /import page). Pass the current input value on every change; it fires a
// single `search_apps` Mixpanel event per search session — debounced so the
// payload holds the actual term typed, guarded so it only fires once, and reset
// when the box is cleared so a fresh search logs again. `source` distinguishes
// which box it came from.
export const useTrackSearch = (source, userId) => {
    const trackedRef = React.useRef(false)
    const timerRef = React.useRef(null)

    React.useEffect(
        () => () => {
            if (timerRef.current) clearTimeout(timerRef.current)
        },
        []
    )

    return value => {
        if (!value) {
            trackedRef.current = false
            if (timerRef.current) clearTimeout(timerRef.current)
            return
        }
        if (trackedRef.current) return
        if (timerRef.current) clearTimeout(timerRef.current)
        timerRef.current = setTimeout(() => {
            trackedRef.current = true
            sendToAnalytics({
                userId,
                event: 'search_apps',
                data: { query: value, source },
            })
        }, 700)
    }
}
